function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M47.2 432.964C-76.349 73.204 502.663-121.393 634.379 175.066c78.368 160.988-1.063 367.987-146.341 483.015C309.368 736.557 112.351 592.36 47.2 432.964z",
  stroke: "currentColor",
  strokeMiterlimit: 10
});

function Svg005(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 696 711",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjk2IDcxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ny4yIDQzMi45NjRDLTc2LjM0OSA3My4yMDQgNTAyLjY2My0xMjEuMzkzIDYzNC4zNzkgMTc1LjA2NmM3OC4zNjggMTYwLjk4OC0xLjA2MyAzNjcuOTg3LTE0Ni4zNDEgNDgzLjAxNUMzMDkuMzY4IDczNi41NTcgMTEyLjM1MSA1OTIuMzYgNDcuMiA0MzIuOTY0eiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8L3N2Zz4=";
export { Svg005 as ReactComponent };